import { render } from "./SubViewHeader.vue?vue&type=template&id=52f9b49e&scoped=true"
import script from "./SubViewHeader.vue?vue&type=script&lang=js"
export * from "./SubViewHeader.vue?vue&type=script&lang=js"

import "./SubViewHeader.vue?vue&type=style&index=0&id=52f9b49e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f9b49e"]])

export default __exports__